import React, { Component } from 'react';
import CardViewKyc from './CardViewKyc';
import IntlMessages from '../../../util/IntlMessages';
import { UPLOAD_FILE, ACCOUNT_UPDATE_KYC } from '../../../constants/apiConstant';
import UtilService from '../../../services/util';
import { LOCAL_STORAGE_VAR, KYC_STATUS } from '../../../constants/Common';
import OpenNotification from '../../common/CommonButton/OpenNotification';

class KycProof extends Component {
  state = {
    Kyc: {
      imageOne: this.props.imageOne,
      imageTwo: this.props.imageTwo,
    },
    isUploaded: this.props.isUploaded ? this.props.isUploaded : false,
    isApproved: this.props.isApproved,
  };
  uploadKyc = (file, name, img) => {
    let self = this;
    let objData = {
      ...UPLOAD_FILE,
      request: file,
    };
    UtilService.callApi(objData, function (err, data) {
      if (err) throw err;
      if (data && data.code === 'OK') {
        if (data.data && data.data.files && data.data.files.length !== 0) {
          if (img === 1) {
            self.setState({
              Kyc: {
                imageTwo: self.state.Kyc.imageTwo,
                imageOne: data.data.files[0].absolutePath || data.data.files[0].absolutePath.path,
              },
            });
          } else {
            self.setState({
              Kyc: {
                imageOne: self.state.Kyc.imageOne,
                imageTwo: data.data.files[0].absolutePath || data.data.files[0].absolutePath.path,
              },
            });
          }
        }
        OpenNotification({
          type: 'success',
          title: 'Document uploaded successfully.',
        });
      }
    });
  };
  createKyc = () => {
    let self = this;
    if (self.state.Kyc && self.state.Kyc.imageOne !== '' && self.state.Kyc.imageTwo !== '') {
      let user = UtilService.getLocalStorageItem(`${LOCAL_STORAGE_VAR}-user`);
      let objReq = {
        url: ACCOUNT_UPDATE_KYC.url + user?.account?.id,
        method: ACCOUNT_UPDATE_KYC.method,
        showLoader: ACCOUNT_UPDATE_KYC.showLoader,
        request: {
          kyc: [{ path: self.state.Kyc.imageOne }, { path: self.state.Kyc.imageTwo }],
          isKycUploaded: true,
          isApproved: KYC_STATUS.PENDING,
        },
      };
      UtilService.callApi(objReq, function (err, data) {
        if (err) throw err;
        if (data && data.code === 'OK') {
          user.account.kyc = objReq?.request?.kyc;
          user.account.isKycUploaded = true;
          user.account.isApproved = KYC_STATUS.PENDING;
          self.setState({ isUploaded: true, isApproved: KYC_STATUS.PENDING });
          UtilService.setLocalStorageItem(user, `${LOCAL_STORAGE_VAR}-user`);
          OpenNotification({
            type: 'success',
            title: 'Your KYC documents are successfully submitted.',
          });
        }
      });
    } else {
      OpenNotification({
        type: 'error',
        title: 'Please upload both the images',
      });
    }
  };
  render() {
    let { Kyc, isUploaded, isApproved } = this.state;
    return (
      <>
        <CardViewKyc
          isApproved={isApproved}
          isUploaded={isUploaded}
          image={Kyc.imageOne}
          title="Personal Identity Proof"
          removeDoc={() => {
            let self = this;
            self.setState({
              Kyc: {
                imageOne: '',
                imageTwo: self.state.Kyc.imageTwo,
              },
            });
          }}
          fileApi={(file, name, one) => {
            this.uploadKyc(file, name, 1);
          }}
        />
        <CardViewKyc
          isApproved={isApproved}
          removeDoc={() => {
            let self = this;
            self.setState({
              Kyc: {
                imageOne: self.state.Kyc.imageOne,
                imageTwo: '',
              },
            });
          }}
          isUploaded={isUploaded}
          image={Kyc.imageTwo}
          title="Business Identity Proof"
          fileApi={(file, name, two) => {
            this.uploadKyc(file, name, 2);
          }}
        />
        <span style={{ marginLeft: '3px', color: '#4eb45e' }}>
          <strong>Note :</strong> Photo Identification Proof(PAN Card or Passport) and Business Identification proof(GST
          or PAN Card or Business Registration Certificate)
        </span>
        {!isUploaded && (
          <>
            <div className="botoomStickyBar diamondListingAction justify-content-center">
              <a className="bottomStickyButton" onClick={() => this.createKyc()}>
                <IntlMessages id="app.signup.Submit" />
              </a>
              {/* <a className="bottomStickyButton" >
                                <IntlMessages id="app.Cancel" />
                            </a> */}
            </div>
          </>
        )}
        {isUploaded && isApproved === KYC_STATUS.REJECT && (
          <>
            <div className="botoomStickyBar diamondListingAction justify-content-center">
              <a className="bottomStickyButton" onClick={() => this.createKyc()}>
                <IntlMessages id="app.signup.Submit" />
              </a>
              {/* <a className="bottomStickyButton" >
                        <IntlMessages id="app.Cancel" />
                    </a> */}
            </div>
          </>
        )}
      </>
    );
  }
}
export default KycProof;
